import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routes from './pages/Routes.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import hh_logo_color from './assets/hh_logo_color.png';
import {Helmet, HelmetProvider } from "react-helmet-async";
import store from './app/store'
import {Provider} from 'react-redux'

ReactDOM.render(
  <HelmetProvider>
    <React.StrictMode>
    <Provider store={store}>
      <Helmet>
        <meta property="og:url"                content="http://www.handlhealth.com" />
        <meta property="og:type"               content="home" />
        <meta property="og:title"              content="Handl Health" />
        <meta property="og:description"        content="See personalized cost estimates of healthcare services in your area." />
        <meta property="og:image"              content={hh_logo_color} />
        <meta name="description"               content="See personalized cost estimates of healthcare services in your area." />
        <title>Handl Health</title>
      </Helmet>
      <Routes />
    </Provider>
    </React.StrictMode>
  </HelmetProvider>,
  document.getElementById('root')
);
